import { StatusProcuracaoEnum } from "core/features/assembleia/typings/procuracao";

export function getTagVariantForStatus(status: StatusProcuracaoEnum) {
  if (status === StatusProcuracaoEnum.Rejeitada) {
    return "solid";
  }
  return "outline";
}

export function getTagColorSchemeForStatus(status: StatusProcuracaoEnum) {
  switch (status) {
    case StatusProcuracaoEnum.Aprovada:
      return "green";
    case StatusProcuracaoEnum.Pendente:
    case StatusProcuracaoEnum.Rejeitada:
      return "red";
    case StatusProcuracaoEnum.EmAnalise:
      return "orange";
    default:
      return "gray";
  }
}
